<template>
  <div class="accounts-header">
    <v-list dark dense class="py-0">
      <v-list-tile
        class="v-list__tile--divider accounts-header__all-tile"
        avatar
        ripple
        :href="returnUrl"
      >
        <v-list-tile-action>
          <v-icon
            large
            color="white"
          >
            home
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Home
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon color="white">keyboard_arrow_right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
  import siteUrls from '@/helpers/site_urls'

  export default {
    computed: {
      returnUrl () {
        return siteUrls.secureSite
      }
    }
  }
</script>

<style lang="stylus">
  @import '~styles/bonsai/_settings.styl'

  .accounts-header
    &__all-tile
      .v-list__tile
        font-size: $list-tile-font-size
</style>



// WEBPACK FOOTER //
// frontend/src/components/list/AccountsHeader.vue